import { Builder, withChildren } from "@builder.io/react";
import ContentCard from "./card/card";
import ContentFeature from "./feature/feature";
import BuilderButton from "./buttons/builder-button";
import DepartureBoard from "./departure-board/departure-board";
import ContentTimetable from "./timetable/content-timetable";
import PageHeader from "./page-header/page-header";
import { lazy } from "react";
import PageHero from "./page-hero/page-hero";
import Accordian from "./accordian/accordian-builder";
import VideoEmbed from "./video/video-embed";
import FAQNavbar from "../components/navigation/faq-nav-bar";
Builder.registerComponent(withChildren(ContentCard), {
  name: "Card",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
  inputs: [{ name: "heading", type: "text", defaultValue: "Card Title" }],
});

Builder.registerComponent(withChildren(ContentFeature), {
  name: "Feature Card",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
  inputs: [
    { name: "heading", type: "text", defaultValue: "Card Title" },
    { name: "image", type: "file", allowedFileTypes: ["jpeg", "png", "svg"] },
  ],
  canHaveChildren: true,
});

Builder.registerComponent(BuilderButton, {
  name: "Button",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
  inputs: [
    { name: "label", type: "text", defaultValue: "Click Here" },
    {
      name: "page",
      type: "reference",
      model: "page",
    },
    {
      name: "variant",
      type: "string",
      enum: ["Primary", "Secondary", "Primary.Outline"],
      defaultValue: "Primary",
    },
    { name: "link", type: "text" },
    { name: "openInNewTab", type: "boolean", defaultValue: false },
  ],
  canHaveChildren: false,
});

Builder.registerComponent(
  withChildren(DepartureBoard),

  {
    name: "Departure Board",
    inputs: [{ name: "disabled", type: "boolean", defaultValue: false }],
    image:
      "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
    canHaveChildren: true,
  }
);

Builder.registerComponent(ContentTimetable, {
  name: "Timetable",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
});
Builder.registerComponent(VideoEmbed, {
  name: "Video Embed",
  inputs: [
    { name: "url", type: "string" },
    { name: "poster", type: "file", allowedFileTypes: ["jpeg", "png"] },
  ],
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
});

Builder.registerComponent(PageHeader, {
  name: "Page Header",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
});

Builder.registerComponent(PageHero, {
  name: "Hero",
  /*  defaultChildren: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "Image",
          options: { text: "Insert your Bakground image" },
        },
      },
    ], */
  inputs: [
    { name: "message", type: "richText" },
    { name: "image", type: "file", allowedFileTypes: ["jpeg", "png"] },
  ],

  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
});

Builder.registerComponent(Accordian, {
  name: "Accordian",
  inputs: [
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "label",
          type: "text",
          defaultValue: "New tab",
        },
        {
          name: "content",
          type: "uiBlocks",
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          label: "Accordian 1",
          content: [],
        },
      ],
    },
  ],
});

Builder.registerComponent(FAQNavbar, {
  name: "FAQ Navbar",
  image:
    "https://tabler-icons.io/static/tabler-icons/icons-png/exposure-plus-1.png",
});
